module.exports = __webpack_public_path__ + "static/media/voltmill-1.ecf8883c.jpg";